export const aboutContactCta = {
  fr: {
    title: "Contactez-nous",
    body: "",
    button: "Contactez-nous",
  },
  en: {
    title: "Contact Us",
    body: "",
    button: "Contact us",
  },
};

export const publicFormsContent = {
  contact: {
    fr: {
      title: "Contactez-nous",
      intro: "Une question sur une commande, un produit ou une disponibilité? Écrivez-nous et nous vous répondrons dès que possible.",
      formTitle: "Votre message",
      formIntro: "Partagez vos coordonnées et quelques détails pour que nous puissions bien vous aider.",
      submit: "Envoyer",
      success: "Votre demande a bien été envoyée.",
      error: "La demande n’a pas pu être envoyée pour le moment.",
      configError: "Le point de terminaison du formulaire public n’est pas configuré.",
      fields: {
        firstName: "Prénom",
        lastName: "Nom",
        customerType: "Type de client",
        email: "Adresse courriel",
        cellNumber: "Numéro de cellulaire",
        details: "Détails",
      },
      customerTypePlaceholder: "Sélectionner un type de client",
      options: {
        professional: "Professionnel",
        individual: "Particulier",
      },
    },
    en: {
      title: "Contact Us",
      intro: "Questions about an order, a product, or availability? Send us a note and we will get back to you as soon as we can.",
      formTitle: "Your message",
      formIntro: "Share your contact details and a few details about what you need so we can help properly.",
      submit: "Send",
      success: "Your message has been sent.",
      error: "We could not send your message right now.",
      configError: "The public form endpoint is not configured.",
      fields: {
        firstName: "First Name",
        lastName: "Last Name",
        customerType: "Customer Type",
        email: "Email Address",
        cellNumber: "Cell Number",
        details: "Details",
      },
      customerTypePlaceholder: "Select a customer type",
      options: {
        professional: "Professional",
        individual: "Individual",
      },
    },
  },
  trade: {
    fr: {
      title: "Devenir client professionnel",
      intro: "Parlez-nous de votre établissement et de ce que vous recherchez. Nous reviendrons vers vous rapidement.",
      formTitle: "Votre établissement",
      formIntro: "Présentez brièvement votre établissement afin de nous donner le bon contexte.",
      submit: "Envoyer la demande",
      success: "Votre demande professionnelle a bien été envoyée.",
      error: "La demande n’a pas pu être envoyée pour le moment.",
      configError: "Le point de terminaison du formulaire public n’est pas configuré.",
      fields: {
        firstName: "Prénom",
        lastName: "Nom",
        establishment: "Établissement",
        email: "Adresse courriel",
        cellNumber: "Numéro de cellulaire",
      },
    },
    en: {
      title: "Become a Trade Client",
      intro: "Tell us about your establishment and what you are looking for. We will follow up shortly.",
      formTitle: "Your establishment",
      formIntro: "A short description of your establishment helps us respond with the right context.",
      submit: "Send request",
      success: "Your trade request has been sent.",
      error: "We could not send your request right now.",
      configError: "The public form endpoint is not configured.",
      fields: {
        firstName: "First Name",
        lastName: "Last Name",
        establishment: "Establishment",
        email: "Email Address",
        cellNumber: "Cell Number",
      },
    },
  },
  newsletter: {
    fr: {
      title: "M’abonner à l’infolettre",
      intro: "Inscrivez-vous pour recevoir les nouveautés, arrivages et sélections Boires.",
      formTitle: "Votre inscription",
      formIntro: "Laissez-nous vos coordonnées et choisissez le profil qui vous correspond.",
      submit: "S’abonner",
      success: "Votre inscription a bien été enregistrée.",
      error: "L’inscription n’a pas pu être complétée pour le moment.",
      configError: "Le point de terminaison de l’infolettre n’est pas configuré.",
      fields: {
        firstName: "Prénom",
        lastName: "Nom",
        email: "Adresse e-mail",
        phone: "Téléphone",
        customerType: "Type de client",
        companyName: "Nom de l’entreprise",
      },
      customerTypePlaceholder: "Sélectionner un profil",
      customerTypes: [
        { value: "INDIVIDUAL_QC", label: "Particulier – Québec" },
        { value: "INDIVIDUAL_ON", label: "Particulier – Ontario" },
        { value: "PROFESSIONAL_QC", label: "Professionnel – Québec" },
        { value: "PROFESSIONAL_ON", label: "Professionnel – Ontario" },
      ],
    },
    en: {
      title: "Subscribe to Newsletter",
      intro: "Sign up to receive Boires news, arrivals, and selections.",
      formTitle: "Your signup",
      formIntro: "Leave your details and choose the profile that fits you best.",
      submit: "Subscribe",
      success: "Your subscription has been saved.",
      error: "We could not complete the subscription right now.",
      configError: "The newsletter endpoint is not configured.",
      fields: {
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email Address",
        phone: "Phone Number",
        customerType: "Customer Type",
        companyName: "Company Name",
      },
      customerTypePlaceholder: "Select a profile",
      customerTypes: [
        { value: "INDIVIDUAL_QC", label: "Individual – Quebec" },
        { value: "INDIVIDUAL_ON", label: "Individual – Ontario" },
        { value: "PROFESSIONAL_QC", label: "Professional – Quebec" },
        { value: "PROFESSIONAL_ON", label: "Professional – Ontario" },
      ],
    },
  },
  faq: {
    fr: {
      title: "FAQ",
      intro: "Retrouvez les réponses publiées par Boires pour le Québec et l’Ontario, organisées par thème.",
      empty: "Aucune réponse disponible pour ce marché dans cette section.",
      loading: "Chargement de la FAQ...",
      error: "Impossible de charger la FAQ pour le moment.",
    },
    en: {
      title: "FAQ",
      intro: "Browse answers published by Boires for Quebec and Ontario, organized by topic.",
      empty: "No answers are available for this market in this section.",
      loading: "Loading FAQ...",
      error: "We could not load the FAQ right now.",
    },
  },
};
